import { apiGet } from '../api'

export const get_user_profile = () => {
  return apiGet({
    endpoint: 'user/get_user_profile'
  })
}
